import { FC } from 'react'
import { AppHead } from 'client/components/Layout/components/AppHead/AppHead'
import { WebsiteBuilderPageContent } from 'client/contents/WebsiteBuilderContent/WebsiteBuilderPageContent'

type TProps = {}

const WebsiteBuilderPage: FC<TProps> = () => {
  return (
    <article className="flex w-full flex-col bg-surface-white">
      <AppHead />
      <WebsiteBuilderPageContent />
    </article>
  )
}

export default WebsiteBuilderPage
